// extracted by mini-css-extract-plugin
export default {"genericCard":"lr-z","inline":"mr-z","mastercard":"nr-z","discover":"or-z","visa":"pr-z","amex":"qr-z","active":"rr-z"};